export default "__VITE_ASSET__lUjW$KdC__"